export enum  TripPatternStatus {
    IN_PROGRESS = 1,    // en progreso
    READY = 2,         // listo
}